import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"
import { RelatedToStorageFeesStep } from "#/components/carrot-card-cost-share/steps/views/RelatedToStorageFeesStep"
import { WhoWillReceiveCareStep } from "#/components/carrot-card-cost-share/steps/views/WhoWillReceiveCareStep"
import { RelatedToMedicationExpensesPreservationStep } from "#/components/carrot-card-cost-share/steps/views/RelatedToMedicationExpensesPreservationStep"
import { RelatedToInfertilityDiagnosisStep } from "#/components/carrot-card-cost-share/steps/views/RelatedToInfertilityDiagnosisStep"
import { ConsideredMedicallyNecessaryPreservationStep } from "#/components/carrot-card-cost-share/steps/views/CareConsideredMedicallyNecessaryPreservationStep"
import {
  GeneralSteps,
  PreservationSteps,
  SectionName
} from "#/components/carrot-card-cost-share/workflows/step-library"
import { RelatedToStorageFeesValues } from "#/components/carrot-card-cost-share/steps/shared/stepOptionValues"

export enum Workflows {
  PRESERVATION = "Preservation Workflow"
}

export const preservationSteps = [
  { name: PreservationSteps.RELATED_TO_STORAGE_FEES_PRESERVATION, component: RelatedToStorageFeesStep },
  { name: PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION, component: ExpenseNotCoveredStep },
  { name: PreservationSteps.WHO_WILL_RECEIVE_CARE_PRESERVATION, component: WhoWillReceiveCareStep },
  {
    name: PreservationSteps.RELATED_TO_MEDICATION_EXPENSES_PRESERVATION,
    component: RelatedToMedicationExpensesPreservationStep
  },
  {
    name: PreservationSteps.RELATED_TO_INFERTILITY_DIAGNOSIS_PRESERVATION,
    component: RelatedToInfertilityDiagnosisStep
  },
  {
    name: PreservationSteps.CONSIDERED_MEDICALLY_NECESSARY_PRESERVATION,
    component: ConsideredMedicallyNecessaryPreservationStep
  }
]

//prettier-ignore
const preservationFlow: PreservationFlowTransition[] = [
  { at: PreservationSteps.RELATED_TO_STORAGE_FEES_PRESERVATION,          given: RelatedToStorageFeesValues.OTHER,                            goto: PreservationSteps.WHO_WILL_RECEIVE_CARE_PRESERVATION },
  { at: PreservationSteps.RELATED_TO_STORAGE_FEES_PRESERVATION,          given: RelatedToStorageFeesValues.FIRST_YEAR_STORAGE,               goto: PreservationSteps.WHO_WILL_RECEIVE_CARE_PRESERVATION },
  { at: PreservationSteps.RELATED_TO_STORAGE_FEES_PRESERVATION,          given: RelatedToStorageFeesValues.POST_FIRST_YEAR_STORAGE,          goto: PreservationSteps.WHO_WILL_RECEIVE_CARE_PRESERVATION },
  { at: PreservationSteps.RELATED_TO_STORAGE_FEES_PRESERVATION,          given: "NO_ELECTIVE_PRES_COVERAGE",                                 goto: PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION },
  { at: PreservationSteps.WHO_WILL_RECEIVE_CARE_PRESERVATION,            given: "INELIGIBLE",                                                goto: PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION },
  { at: PreservationSteps.WHO_WILL_RECEIVE_CARE_PRESERVATION,            given: "ELIGIBLE",                                                  goto: PreservationSteps.RELATED_TO_MEDICATION_EXPENSES_PRESERVATION },
  { at: PreservationSteps.RELATED_TO_MEDICATION_EXPENSES_PRESERVATION,   given: "COVERED",                                                   goto: PreservationSteps.RELATED_TO_INFERTILITY_DIAGNOSIS_PRESERVATION },
  { at: PreservationSteps.RELATED_TO_MEDICATION_EXPENSES_PRESERVATION,   given: "NOT_COVERED",                                               goto: PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION },
  { at: PreservationSteps.RELATED_TO_INFERTILITY_DIAGNOSIS_PRESERVATION, given: "",                                                          goto: PreservationSteps.CONSIDERED_MEDICALLY_NECESSARY_PRESERVATION },
  { at: PreservationSteps.CONSIDERED_MEDICALLY_NECESSARY_PRESERVATION,   given: "INELIGIBLE",                                                goto: PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION },
  { at: PreservationSteps.CONSIDERED_MEDICALLY_NECESSARY_PRESERVATION,   given: "ELIGIBLE",                                                  goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL },
  { at: PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION,              given: "",                                                          end: true }
]

type PreservationFlowTransition =
  | { at: PreservationSteps; given: string; goto: PreservationSteps; sectionName?: undefined }
  | { at: PreservationSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: PreservationSteps; given: string; end: true }

export const preservationWorkflows = [{ name: Workflows.PRESERVATION, workflow: preservationFlow }]
